import { cn } from '@divlab/divanui';

import H3 from '@Components/H3';
import styles from './ExplanationsBlock.module.css';

import type { ExplanationsData } from '@Pages/PageCredit/typings';
import type { FC, HTMLAttributes } from 'react';

interface ExplanationsBlockProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  list?: ExplanationsData[];
}

const ExplanationsBlock: FC<ExplanationsBlockProps> = (props) => {
  const { title, list, className } = props;

  return (
    <div className={cn(styles.main, className)}>
      {title && <H3 className={styles.title} title={title} />}

      {(list || []).map((item) => {
        return (
          <div className={styles.questionContainer} key={item.question}>
            <span className={styles.question}>{item.question}</span>
            <span className={styles.answer}>{item.answer}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ExplanationsBlock;
